import type { CustomerAddressDTO } from '@/server/dto/customer-address-dto';
import { safeJoin } from '@/utils/string-utils';

export type AddressLike = Omit<CustomerAddressDTO, 'addressId' | 'customerId' | 'type'>;

/**
 * Creates a formatted address string from customer data
 * - Removes redundant address lines (lines in customer_name or street)
 * - Adds proper spacing between street number and postal code
 */
export const getFullAddressString = (
    address: AddressLike,
    customerName?: string,
    delimiter = ', ',
): string => {
    return safeJoin(
        [
            ...[address.addressLine1, address.addressLine2, address.addressLine3].filter(
                (line) => line && !address.street?.includes(line) && !customerName?.includes(line),
            ),
            address.street,
            safeJoin([address.zipCode, address.city], ' '),
            address.country || address.countryCode,
        ],
        delimiter,
    );
};
